export default __webpack_public_path__ + "static/media/bi_whatsapp.25fab71d.svg";